import { db } from "../firebase/config";
import { collection, doc, addDoc, updateDoc, deleteDoc, onSnapshot } from "firebase/firestore";

export function subscribeToAcquisitions(callback) {
  return onSnapshot(collection(db, "acquisitions"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    // Sort by ACQ Number descending
    list.sort((a, b) => (b.acqNumber || "").localeCompare(a.acqNumber || ""));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to acquisitions:", error);
    callback([], error);
  });
}

export async function seedAcquisitionsIfEmpty(acqs, vendorList) {
  if (acqs.length > 0) return;

  const atlas = vendorList.find(v => v.name.includes("Atlas"))?.name || "Atlas Shipping Co.";
  const apex = vendorList.find(v => v.name.includes("Apex"))?.name || "Apex Manufacturing Ltd.";
  const globalwh = vendorList.find(v => v.name.includes("Global"))?.name || "Global Warehousing Corp.";
  
  const mockACQs = [
    { acqNumber: "ACQ-2026-001", vendorName: atlas, vendorId: vendorList.find(v => v.name.includes("Atlas"))?.id || "", date: "2026-06-10", items: "Global shipping freight container service", totalCost: 12500, status: "Delivered" },
    { acqNumber: "ACQ-2026-002", vendorName: apex, vendorId: vendorList.find(v => v.name.includes("Apex"))?.id || "", date: "2026-06-15", items: "150x Heavy Duty Aluminum Castings", totalCost: 45000, status: "Approved" },
    { acqNumber: "ACQ-2026-003", vendorName: globalwh, vendorId: vendorList.find(v => v.name.includes("Global"))?.id || "", date: "2026-06-20", items: "Warehouse storage lease - Zone 4B", totalCost: 18200, status: "Pending Approval" },
    { acqNumber: "ACQ-2026-004", vendorName: "Pacific Custom Brokerage", vendorId: "", date: "2026-06-22", items: "Customs clearance fees - Shipment #99A", totalCost: 8900, status: "Draft" }
  ];

  for (const acq of mockACQs) {
    try {
      await addDoc(collection(db, "acquisitions"), acq);
    } catch(e) {
      console.error(e);
    }
  }
}

export async function addAcquisition(acqData) {
  const docRef = await addDoc(collection(db, "acquisitions"), acqData);
  return docRef.id;
}

export async function updateAcquisition(id, acqData) {
  const docRef = doc(db, "acquisitions", id);
  await updateDoc(docRef, acqData);
}

export async function deleteAcquisition(id) {
  const docRef = doc(db, "acquisitions", id);
  await deleteDoc(docRef);
}
